import {zoomIntegrationActionTypes} from "../_constants/actions/integrations/zoomIntegrationActiontypes";

export function integrations(state = {}, action) {
    switch(action.type) {

        // zoom-integration connect request
        case zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_REQUEST:
            return {
                ...state,
                zoom: {
                    connect: {
                        loading: true,
                        code: action.code,
                    }
                }
            };

        // zoom-integration connect success
        case zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_SUCCESS:
            return {
                ...state,
                zoom: {
                    connect: {
                        loaded: true,
                        code: action.code,
                    }
                }
            };

        // zoom-integration connect failure
        case zoomIntegrationActionTypes.CONNECT_ZOOM_INTEGRATION_FAILURE:
            return {
                ...state,
                zoom: {
                    connect: {
                        error: action.error
                    }
                }
            };

        case zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_REQUEST:
            return {
                ...state,
                zoom: {
                    getRecordings: {
                        query: action.query,
                        loading: true
                    }
                }
            };

        case zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_SUCCESS:
            return {
                ...state,
                zoom: {
                    getRecordings: {
                        data: action.response,
                        loaded: true
                    }
                }
            };

        case zoomIntegrationActionTypes.RECORDINGS_ZOOM_INTEGRATION_FAILURE:
            return {
                ...state,
                zoom: {
                    getRecordings: {
                        loading: false,
                        loaded: false,
                        failed: true
                    }
                }
            };

        case zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_REQUEST:
            return {
                ...state,
                zoom: {
                    disconnect: {
                        loading: true
                    }
                }
            };


        case zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_SUCCESS:
            return {
                ...state,
                zoom: {
                    disconnect: {
                        loaded: true
                    }
                }
            };

        case zoomIntegrationActionTypes.DISCONNECT_ZOOM_INTEGRATION_FAILURE:
            return {
                ...state,
                zoom: {
                    disconnect: {
                        error: action.error
                    }
                }
            };

        case zoomIntegrationActionTypes.RE_CONNECT_ZOOM_INTEGRATION_INDICATOR:
            return {
                ...state,
                zoom: {
                    reconnect: true
                }
            };

        default:
            return state;
    }
}